'use client';

import { useEffect, useState } from 'react';
import ModalContent from './ModalContent';
import type { ModalProps } from './types'; // Ajustez le chemin selon votre projet

const Modal = (props: ModalProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return <ModalContent {...props} />;
};

export default Modal;